<template>
  <file-pond
      ref="pond"
      name="file"
      allow-multiple
      :max-file-size="maxSize"
      :accepted-file-types="['image/jpeg', 'image/png']"
      :files="formattedInitialFiles"
      :server="serverConfig"
      @addfilestart="onAddFileStart"
      @processfiles="onProcessFiles"
      @processfile="onFileUploaded"
      @removefile="onFileRemoved"
  />
</template>

<script>
  import vueFilePond from 'vue-filepond'
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
  import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'

  import 'filepond/dist/filepond.min.css'
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

  const FilePond = vueFilePond(
      FilePondPluginImagePreview,
      FilePondPluginFileValidateType,
      FilePondPluginFileValidateSize
  )

  export default {
    name: 'FilePondUploader',
    components: { FilePond },
    props: {
      initialFiles: {
        type: Array,
        default: () => []
      },
      maxSize: {
        type: String,
        default: '5MB'
      }
    },
    data() {
      return {
        uploadedFiles: []
      }
    },
    computed: {
      formattedInitialFiles() {
        return this.initialFiles.map(file => ({
          source: file.url,
          options: {
            type: 'local',
            metadata: {
              id: file.id,
              imageId: file.imageId
            }
          }
        }))
      },
      serverConfig() {
        return {
          process: {
            url: 'http://localhost:8222/api/v1/upload/unsigned',
            method: 'POST',
            withCredentials: false,
            timeout: 7000,
            onload: response => {
              const res = JSON.parse(response)
              return JSON.stringify(res) // important pour @uploaded
            },
            onerror: err => {
              console.error('Erreur upload:', err)
            }
          },
          load: (source, load, error, progress, abort) => {
            fetch(source)
                .then(res => res.blob())
                .then(blob => load(blob))
                .catch(err => {
                  console.error('Erreur de preview:', err)
                  error(err)
                })
          },
          revert: null
        }
      }
    },
    methods: {
      onAddFileStart() {
        this.$loading(true)
      },
      onProcessFiles() {
        this.$loading(false)
      },
      onFileUploaded(error, file) {
        if (error) {
          console.error('Upload échoué:', error)
          this.$loading(false)
          return
        }
        const res = JSON.parse(file.serverId)
        const uploaded = { id: res.id, url: res.url, imageId: res.imageId }
        this.uploadedFiles.push(uploaded)
        this.$emit('uploaded', this.uploadedFiles)

        // si tu veux encore vérifier que tout est fini côté composant:
        // (évite les "magic numbers" de statut, l’event @processfiles est plus fiable)
      },
      onFileRemoved(fileItem) {
        const url = fileItem?.source
        this.$emit('removefile', url)
      },
      reset() {
        // le composant proxy expose bien removeFiles()
        this.$refs.pond && this.$refs.pond.removeFiles()
        this.uploadedFiles = []
      }
    },

  }
</script>
